import { AiSummaryIcon } from "@edgetier/components";
import { Stack } from "../../stack";
import { Text } from "../../text";
import styles from "./auto-qa-message.module.scss";
import { Group } from "../../group";
import { IProps } from "./auto-qa-message.types";
import { formatDate } from "@edgetier/utilities";

/**
 * AutoQA Message Component
 *
 * Displays metadata for an automated QA entry including the creation date,
 * author label ("Auto QA"), and an optional description. Dates are formatted
 * in the style `12 Apr 2025` using `toLocaleDateString`.
 *
 * @component
 * @param {Object} props - Component properties
 * @param {Date} props.createdAt - The creation date of the QA item
 * @param {string} props.description - Optional description text
 * @returns {JSX.Element} A formatted QA info block
 */
const AutoQAMessage = ({ createdAt, description }: IProps) => {
    return (
        <Stack p="lg" bg="var(--surface-gray-transparent)" gap="md" bdrs="var(--mantine-radius-md2)">
            {createdAt && (
                <Text dimmed size="sm">
                    Created · {formatDate(createdAt, { explicitFormat: "dd MMM yyyy" })}
                </Text>
            )}
            <Group gap="xs">
                {createdAt && (
                    <Text dimmed size="lg" variant="bold">
                        by
                    </Text>
                )}
                <Text size="lg" variant="bold" className={styles.title}>
                    Auto QA
                </Text>
                <AiSummaryIcon />
            </Group>
            {description && <Text size="sm">{description}</Text>}
        </Stack>
    );
};

export { AutoQAMessage };
